import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import SpinningButton from '../SpinBlocking/SpinningButton';
import { wizardStyles } from './WizardStylesContext'
import { OperationInProgressContext } from '../../contexts/OperationInProgressContext/OperationInProgressContext'
import { scrollToElement } from '../../contexts/ScrollContext';
import { ChevronRight } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';

function WizardStepButtons(props) {
  const {
    formData = {},
    onNext = () => {},
    onOtherNext = () => {},
    nextStep = () => {},
    finish = () => {},
    onFinish,
    totalSteps = 0,
    currentStep = 0,
    validForm = true,
    showOtherNext,
    showNext = true,
    showTerminate = false,
    otherNextLabel,
    spinOnClick = true,
    otherSpinOnClick = true,
    terminateLabel,
    nextLabel = 'OnboardingWizardContinue',
    startOver,
    nextDisabled = false,
    terminateSpinOnClick = false,
    onNextDoAdvance = true,
    onOtherNextDoAdvance = true,
    otherNextValid = false,
    isFinal = true,
    isOtherFinal,
    skipNextStep,
    onOtherNextSkipStep,
    nextShowEdit,
    otherNextShowEdit,
    focus
  } = props;
  const intl = useIntl();
  const classes = wizardStyles();
  const { parentElementId } = formData;
  const [, setOperationRunning] = useContext(OperationInProgressContext);
  const lastStep = currentStep === totalSteps - 1; //zero indexed

  function onTerminate() {
    startOver();
    if (onFinish) {
      onFinish();
    }
  }

  async function nextState(nextFunction, isOtherNext=false) {
    const nextReturn = nextFunction();
    const doAdvance = (!isOtherNext && onNextDoAdvance)||(isOtherNext && onOtherNextDoAdvance);
    if (doAdvance) {
      if (lastStep) {
        const resolved = await Promise.resolve(nextReturn);
        return finish(resolved);
      }
      if (skipNextStep || (isOtherNext && onOtherNextSkipStep)) {
        nextStep(2);
      } else {
        nextStep();
      }
    }
    if (nextReturn) {
      return nextReturn.then(() => {
        setOperationRunning(false);
        const item = document.getElementById(`workListItem${parentElementId}`);
        if (item) {
          scrollToElement(item);
        }
      });
    }
    const item = document.getElementById(`workListItem${parentElementId}`);
    if (item) {
      scrollToElement(item);
    }
  }

  async function myNext () {
    return nextState(onNext);
  }

  async function myOtherNext () {
    return nextState(onOtherNext, true);
  }

  const nextIsDisabled = !validForm || nextDisabled;
  const otherDisabled = !validForm && !otherNextValid;
  const nextClass = isFinal || nextIsDisabled ? classes.actionPrimary : classes.actionNext;
  const nextOtherClass = isOtherFinal === undefined ? nextClass :
    ((isOtherFinal || otherDisabled) ? classes.actionPrimary : classes.actionNext);
  const isNextNext = nextClass === classes.actionNext;
  const isOtherNextNext = nextOtherClass === classes.actionNext;
  return (
    <div className={classes.buttonContainer}>
      {showNext && (
        <SpinningButton id="OnboardingWizardNext" className={nextClass} disabled={nextIsDisabled} onClick={myNext}
                        endIcon={nextShowEdit ? EditIcon : (isNextNext ? ChevronRight : undefined)}
                        iconColor={isNextNext ? 'black' : 'white'} focus={focus}
                        doSpin={spinOnClick}>
          {intl.formatMessage({ id: nextLabel })}
        </SpinningButton>
      )}

      <div className={classes.actionContainer}>
        {showOtherNext && (
          <SpinningButton id="OnboardingWizardOtherNext" className={nextOtherClass} disabled={otherDisabled}
                          endIcon={otherNextShowEdit ? EditIcon : (isOtherNextNext ? ChevronRight : undefined)}
                          iconColor={isOtherNextNext ? 'black' : 'white'}
                          doSpin={otherSpinOnClick} onClick={myOtherNext}>
            {intl.formatMessage({ id: otherNextLabel })}
          </SpinningButton>
        )}
      </div>
      <div className={classes.actionContainer}>
        {showTerminate && (
          <SpinningButton id="OnboardingWizardSkip" className={classes.actionSkip} variant="text"
                          doSpin={terminateSpinOnClick} onClick={() => onTerminate()}
                          focus={focus !== false && !showNext}>
            {intl.formatMessage({ id: terminateLabel })}
          </SpinningButton>
        )}
      </div>
    </div>
  );
}

WizardStepButtons.propTypes = {
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  onOtherNext: PropTypes.func,
  previousStep: PropTypes.func,
  nextStep: PropTypes.func,
  onSkip: PropTypes.func,
  totalSteps: PropTypes.number,
  currentStep: PropTypes.number,
  validForm: PropTypes.bool,
  startOver: PropTypes.func,
  showSkip: PropTypes.bool,
  terminateLabel: PropTypes.string,
  finish: PropTypes.func,
  onTerminate: PropTypes.func,
  showTerminate: PropTypes.bool,
  startOverLabel: PropTypes.string,
  showNext: PropTypes.bool,
  spinOnClick: PropTypes.bool,
  otherSpinOnClick: PropTypes.bool,
  nextLabel: PropTypes.string,
  nextDisabled: PropTypes.bool,
  terminateSpinOnClick: PropTypes.bool,
  onNextDoAdvance: PropTypes.bool,
  onOtherNextDoAdvance: PropTypes.bool,
  otherNextValid: PropTypes.bool,
  isFinal: PropTypes.bool,
  isOtherFinal: PropTypes.bool
};

export default WizardStepButtons;
